module.exports = __webpack_public_path__ + "static/img/service_items_2.7bec52b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_items_2.jpg
// module id = llRl
// module chunks = 0